import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import IDownloadPurchaseOrderPdfDTO from "../../../models/DTO/IDownloadPurchaseOrderPdfDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetPurchaseOrderDTO from "../../../models/DTO/IGetPurchaseOrderDTO";
import IOnDownloadPurchaseOrderPdfDTO from "../../../models/DTO/IOnDownloadPurchaseOrderPdfDTO";
import IOnGetPurchaseOrderDTO from "../../../models/DTO/IOnGetPurchaseOrderDTO";
import IOnProcessPurchaseOrderDTO from "../../../models/DTO/IOnProcessPurchaseOrderDTO";
import IOnProcessPurchaseOrderItemDTO from "../../../models/DTO/IOnProcessPurchaseOrderItemDTO";
import IOnPurchaseOrderAutoPopulateDTO from "../../../models/DTO/IOnPurchaseOrderAutoPopulateDTO";
import IOnTypeaheadVendorSourceCatalogItemsDTO from "../../../models/DTO/IOnTypeaheadVendorSourceCatalogItemsDTO";
import IProcessPurchaseOrderDTO from "../../../models/DTO/IProcessPurchaseOrderDTO";
import IProcessPurchaseOrderItemDTO from "../../../models/DTO/IProcessPurchaseOrderItemDTO";
import IPurchaseOrderAutoPopulateDTO from "../../../models/DTO/IPurchaseOrderAutoPopulateDTO";
import ITypeaheadVendorSourceCatalogItemsDTO from "../../../models/DTO/ITypeaheadVendorSourceCatalogItemsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import INewPurchase_Order_Item from "../../../models/INewPurchase_Order_Item";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import IPurchase_Order from "../../../models/IPurchase_Order";
import IPurchase_Order_Item from "../../../models/IPurchase_Order_Item";
import IPurchase_Order_ItemUI from "../../../models/IPurchase_Order_ItemUI";
import IPurchase_Order_Progress_State from "../../../models/IPurchase_Order_Progress_State";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source from "../../../models/IVendor_Source";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import PurchaseOrderStateEnum from "../../../models/PurchaseOrderStateEnum";
import UnitOfMeasurementEnum from "../../../models/UnitOfMeasurementEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import CatalogItemService from "../../../services/CatalogItemService";
import OrderEntryService from "../../../services/OrderEntryService";
import PurchaseOrderService from "../../../services/PurchaseOrderService";
import UserService from "../../../services/UserService";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { PurchaseOrderProgressTracker } from "../../shared/PurchaseOrderProgressTracker/PurchaseOrderProgressTracker";
import Typeahead from "../../shared/Typeahead/Typeahead";
import "./PurchaseOrderDetail.scss";
import CreateQboPurchaseOrderSidebar from "./CreateQboPurchaseOrderSidebar/CreateQboPurchaseOrderSidebar";
import IQBODeletePurchaseOrderDTO from "../../../models/DTO/IQBODeletePurchaseOrderDTO";
import { QboViewPurchaseOrderSidebar } from "./QboViewPurchaseOrderSidebar/QboViewPurchaseOrderSidebar";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import SimpleConfirmModal from "../../shared/SimpleConfirmModal/SimpleConfirmModal";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import ISendPurchaseOrderDTO from "../../../models/DTO/ISendPurchaseOrderDTO";
import IOnSendPurchaseOrderDTO from "../../../models/DTO/IOnSendPurchaseOrderDTO";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { PurchaseOrderFileManager } from "../PurchaseOrderFileManager/PurchaseOrderFileManager";
import PurchaseOrderShipmentsDetailView from "../PurchaseOrderShipmentsDetailView/PurchaseOrderShipmentsDetailView";
import ShipmentPackageSidebar from "../../shipments/ShipmentPackageSidebar/ShipmentPackageSidebar";
import IQBOSendPurchaseOrderDTO from "../../../models/DTO/IQBOSendPurchaseOrderDTO";
import IQBOOnSendPurchaseOrderDTO from "../../../models/DTO/IQBOOnSendPurchaseOrderDTO";
import { Socket } from "socket.io-client";
import { ButtonGroup } from "react-bootstrap";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import IAddress from "../../../models/IAddress";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import OwPill from "../../shared/OwPill/OwPill";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../shared/OwAcceptCancelActions/OwAcceptCancelActions";
import { IUiContextModel } from "@contexts/UiContext";
import { PurchaseOrderButtons } from "./PurchaseOrderButtons/PurchaseOrderButtons";
import { IPurchaseOrderButtonsCallbacks } from "./PurchaseOrderButtons/IPurchaseOrderButtonsCallbacks";
import { OtherPurchaseOrderButtons } from "./OtherPurchaseOrderButtons/OtherPurchaseOrderButtons";
import { IOtherPurchaseOrderButtonsCallbacks } from "./OtherPurchaseOrderButtons/IOtherPurchaseOrderButtonsCallbacks";
import { getDimensionUnitAbbreviation } from "@utils/DimensionConversion";
import PricingFormulaService from "@services/PricingFormulaService";

/**
 * Preview a PO line total from its unit price (the vendor/manufacturer cost, not the sales price).
 * Mirrors the server calc: length-priced items run their pricing formula against the unit price and
 * depth; everything else is qty * unit_price. The server recomputes authoritatively on save.
 */
const computePurchaseOrderItemTotal = (item: IPurchase_Order_ItemUI): number => {
    const qty = Number(item.qty || 0);
    const unitPrice = Number(item.unit_price || 0);

    if (!qty || !unitPrice) {
        return 0;
    }

    let baseTotal = qty * unitPrice;

    const expression = item.Catalog_Item?.Pricing_Formula?.expression_template;

    if (expression && item.depth != null) {
        const result = PricingFormulaService.evaluateFormula(expression, {
            qty,
            price: unitPrice,
            depth: Number(item.depth) || 0,
            width: 0,
            height: 0,
        });

        if (result !== undefined) {
            baseTotal = result;
        }
    }

    return item.is_credit ? Math.abs(baseTotal) * -1 : baseTotal;
};

type Props = {
    history: any;
    location: any;
    match: any;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    isReadOnly: boolean;
    uiContext: IUiContextModel;
};

type State = {
    alreadyExists: boolean;
    completedCrumbs: boolean;
    breadcrumbs: IBreadcrumbs[];
    purchaseOrder?: IPurchase_Order;
    purchaseOrderItems?: IPurchase_Order_ItemUI[];
    isInitialData: boolean;
    isDataFetching: boolean;
    purchaseOrderGuid: string;
    detailEditMode: boolean;
    typeaheadItems?: ICatalog_Item[];
    selectedTypeaheadItem?: ICatalog_Item;
    clearTypeahead: boolean;
    qty: number;
    columns: IOwTableCols[];
    currentStep: number;
    nextStep?: number;
    isSubmitActive: boolean;
    order_state_id?: number;
    isReadOnly: boolean;
    sourceElem: string | null;
    sourceRow?: IPurchase_Order_ItemUI;
    isDownloading: boolean;
    sendEmailWithPDF: boolean;
    qboActive: boolean;
};

class PurchaseOrderDetail extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.state = {
            isReadOnly: props.isReadOnly,
            currentStep: 0,
            alreadyExists: false,
            completedCrumbs: false,
            breadcrumbs: [
                {
                    title: "purchase_orders",
                    url: "/purchase_orders",
                },
            ],
            isInitialData: true,
            isDataFetching: false,
            purchaseOrderGuid: this.props.match.params.guid,
            detailEditMode: false,
            clearTypeahead: false,
            isSubmitActive: false,
            qty: 0,
            columns: [],
            sourceElem: null,
            isDownloading: false,
            sendEmailWithPDF: false,
            qboActive: false,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.PurchaseOrderOnGetPurchaseOrder, fn: this.onGetPurchaseOrder },
            { endpoint: EndpointsEnum.CatalogItemOnTypeaheadVendorSourceCatalogItems, fn: this.onTypeaheadCatalogItems },
            { endpoint: EndpointsEnum.PurchaseOrderOnProcessPurchaseOrderItem, fn: this.onProcessPurchaseOrderItem },
            { endpoint: EndpointsEnum.PurchaseOrderOnProcessPurchaseOrder, fn: this.onProcessPurchaseOrder },
            { endpoint: EndpointsEnum.PurchaseOrderOnAutoPopulate, fn: this.onAutoPopulate },
            { endpoint: EndpointsEnum.PurchaseOrderOnDownloadPurchaseOrderPdf, fn: this.onDownloadPdf },
            { endpoint: EndpointsEnum.QBOOnDeletePurchaseOrder, fn: this.onDeleteQboPurchaseOrder },
            { endpoint: EndpointsEnum.PurchaseOrderOnSendPurchaseOrder, fn: this.onSendPurchaseOrder },
            { endpoint: EndpointsEnum.FileUploadOnDeleteFileUpload, fn: this.onDeleteFileUpload },
            { endpoint: EndpointsEnum.FileUploadOnCreateFileUpload, fn: this.onCreateFileUpload },
            { endpoint: EndpointsEnum.QBOOnSendPurchaseOrder, fn: this.onQboSendPurchaseOrder },
            { endpoint: EndpointsEnum.Notify, fn: this.onNotify },
        ];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        this.getPurchaseOrder();
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    onDeleteFileUpload = () => {
        this.getPurchaseOrder();
    };

    onCreateFileUpload = () => {
        this.getPurchaseOrder();
    };

    hasMinimumQtyOrdered = (
        vendorSource: IVendor_Source,
        row: IPurchase_Order_ItemUI
    ): { hasMinOrderQtyOrdered: boolean; minOrderQty: number } => {
        const minOrderQty = CatalogItemService.getVendorSourceMinOrderQty(vendorSource, row.Catalog_Item!);

        const qty = Number(row.qty);

        let hasMinOrderQtyOrdered = true;

        if (qty < minOrderQty) {
            hasMinOrderQtyOrdered = false;
        }

        return { hasMinOrderQtyOrdered, minOrderQty };
    };

    handleRowChange = (e: ChangeEvent<any>, row: IPurchase_Order_ItemUI, minOrderQty?: number) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        // if (name === 'qty') {
        //     value = Number(value);
        //
        //     if (minOrderQty) {
        //         if (value < minOrderQty) {
        //             value = minOrderQty;
        //         }
        //     }
        // }

        const purchaseOrderItems = this.state.purchaseOrderItems;

        if (purchaseOrderItems) {
            for (const item of purchaseOrderItems) {
                if (item.catalog_item_id === row.catalog_item_id && row.guid === item.guid) {
                    // @ts-expect-error
                    item[name] = value;
                    item.total_price = computePurchaseOrderItemTotal(item);
                }
            }
        }

        this.setState({ purchaseOrderItems });
    };

    toggleEditMode = (row: IPurchase_Order_ItemUI, index: number) => {
        const purchaseOrderItems = this.state.purchaseOrderItems;

        let performSave = false;

        if (purchaseOrderItems) {
            for (const item of purchaseOrderItems) {
                if (item.catalog_item_id === row.catalog_item_id && row.guid === item.guid) {
                    if (item.editMode) {
                        performSave = true;
                    }

                    item.editMode = !item.editMode;
                }
            }
        }

        this.setState({ purchaseOrderItems }, () => {
            if (performSave) {
                this.processPurchaseOrderItem(row);
            }
        });
    };

    toggleConfirmDelete = (row: IPurchase_Order_ItemUI, index: number) => {
        const sourceElem = `row-${index}`;

        this.setState({
            sourceElem,
            sourceRow: row,
        });
    };

    cancelDelete = () => {
        this.setState({
            sourceElem: null,
            sourceRow: undefined,
        });
    };

    confirmDelete = () => {
        if (this.state.sourceRow) {
            const payload: IProcessPurchaseOrderItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                deleteFlag: true,
                purchaseOrderItem: this.state.sourceRow,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessPurchaseOrderItem, payload);

            this.setState({
                sourceElem: null,
                sourceRow: undefined,
            });
        }
    };

    renderActionColFn = (row: IPurchase_Order_ItemUI, index: number) => {
        if (this.state.isReadOnly) {
            return <div></div>;
        } else {
            const vendorSource = this.state.purchaseOrder!.Vendor_Source!;

            const { hasMinOrderQtyOrdered, minOrderQty } = this.hasMinimumQtyOrdered(vendorSource, row);

            return (
                <div>
                    <OwDeleteEditActions
                        isEditMode={row.editMode}
                        onTrashClickFn={() => {
                            this.toggleConfirmDelete(row, index);
                        }}
                        onEditClickFn={() => {
                            this.toggleEditMode(row, index);
                        }}
                    />
                    <OwAcceptCancelActions
                        isEditMode={!row.editMode}
                        onAcceptClickFn={() => {
                            this.toggleEditMode(row, index);
                        }}
                        onCancelClickFn={() => {}}
                        disableAccept={!hasMinOrderQtyOrdered}
                        hideCancel={true}
                    />
                </div>
            );
        }
    };

    renderItemNoFn = (row: IPurchase_Order_ItemUI, index: number) => {
        // Server-assigned per-PO number: kit sub-items read as a group (1.1, 1.2, ...), standalone as N.
        return <div>{row.display_item_no || index + 1}</div>;
    };

    renderNameColFn = (row: IPurchase_Order_ItemUI) => {
        const vendorSource = this.state.purchaseOrder!.Vendor_Source!;

        const expectedDate = CatalogItemService.getVendorSourceExpectedDate(vendorSource, row.Catalog_Item!);

        const qboConnectedItem = this.props.supplierModel?.Supplier_Integration?.has_qbo ? (
            row.Catalog_Item?.qbo_item_id ? null : (
                <OwLabel title={"not_quickbooks_connected"} leftIconClass={"fad fa-triangle-exclamation"} className={"text-warning"} />
            )
        ) : null;

        return (
            <div>
                <div>{row.Catalog_Item?.name}</div>
                <div>
                    <OwLabel title={"expected_date"} noBottomMargin={true} postText={":"} className={"me-2"} />
                    {expectedDate}
                    <div>{qboConnectedItem}</div>
                </div>
            </div>
        );
    };

    renderDescriptionColFn = (row: IPurchase_Order_ItemUI) => {
        const itemDescription = row.description || row.Catalog_Item?.description || "";

        if (row.editMode) {
            return (
                <div>
                    <OwTextArea
                        name={"description"}
                        value={itemDescription}
                        fn={(e) => {
                            this.handleRowChange(e, row);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <div>{itemDescription}</div>
                </div>
            );
        }
    };

    renderDepthColFn = (row: IPurchase_Order_ItemUI) => {
        if (row.depth == null) {
            return <div></div>;
        }

        // Raw stored value + unit (e.g. "1500 mm") — no unit conversion.
        return (
            <div className={"no-wrap"}>
                {row.depth} {getDimensionUnitAbbreviation(row.dimension_unit_id)}
            </div>
        );
    };

    renderQtyColFn = (row: IPurchase_Order_ItemUI) => {
        if (row.editMode) {
            const vendorSource = this.state.purchaseOrder!.Vendor_Source!;

            const { hasMinOrderQtyOrdered, minOrderQty } = this.hasMinimumQtyOrdered(vendorSource, row);

            return (
                <>
                    <div>
                        <OwInputWrapper
                            min={minOrderQty}
                            name={"qty"}
                            value={row.qty}
                            supplierModel={this.props.supplierModel}
                            type={"number"}
                            fn={(e: any) => {
                                this.handleRowChange(e, row, minOrderQty);
                            }}
                            className={hasMinOrderQtyOrdered ? "" : "border-danger bg-danger text-white"}
                        />
                        {hasMinOrderQtyOrdered ? null : (
                            <div className={"text-warning no-wrap"}>
                                <OwLabel
                                    leftIconClass={"fad fa-exclamation-triangle"}
                                    title={"min_qty"}
                                    postText={":"}
                                    className={"me-1"}
                                />{" "}
                                {minOrderQty}
                            </div>
                        )}
                    </div>
                    {this.props.supplierModel.has_uom_sets && row.Catalog_Item?.purchasing_base_unit_id ? (
                        <div>{row.Catalog_Item?.Purchasing_Base_Unit?.unit_abbr}</div>
                    ) : null}
                </>
            );
        } else {
            return (
                <>
                    <NumericFormat
                        value={row.qty || 0}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={this.props.supplierModel.qty_precision || 0}
                        fixedDecimalScale={true}
                    />
                    {this.props.supplierModel.has_uom_sets && row.Catalog_Item?.purchasing_base_unit_id ? (
                        <span className={"ms-2"}>{row.Catalog_Item?.Purchasing_Base_Unit?.unit_abbr}</span>
                    ) : null}
                </>
            );
        }
    };

    renderQtyReceivedColFn = (row: IPurchase_Order_ItemUI) => {
        return <div>{row.qty_received}</div>;
    };

    renderUnitPriceColFn = (row: IPurchase_Order_ItemUI) => {
        if (row.editMode) {
            return (
                <OwFnInput
                    fn={(e: any) => {
                        this.handleRowChange(e, row);
                    }}
                    name={"unit_price"}
                    value={row.unit_price}
                    supplierModel={this.props.supplierModel}
                    type={"number"}
                />
            );
        } else {
            return (
                <NumericFormat
                    value={row.unit_price || 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            );
        }
    };

    renderTotalPriceColFn = (row: IPurchase_Order_ItemUI) => {
        return (
            <NumericFormat
                value={row.total_price || 0}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                prefix={"$"}
            />
        );
    };

    getPurchaseOrder = () => {
        const payload: IGetPurchaseOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            purchaseOrderGuid: this.state.purchaseOrderGuid,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetPurchaseOrder, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    getTableColumns = (purchaseOrderItems: IPurchase_Order_ItemUI[] = this.state.purchaseOrderItems || []): IOwTableCols[] => {
        return [
            {
                isActionsCol: true,
                valueProp: "",
                title: "",
                renderFn: this.renderActionColFn,
                renderFnEmitsRow: true,
                className: "w-4r",
            },
            {
                valueProp: "",
                title: "item_no",
                renderFn: this.renderItemNoFn,
                renderFnEmitsRow: true,
                className: "w-5r",
            },
            {
                valueProp: "",
                title: "name",
                renderFn: this.renderNameColFn,
                renderFnEmitsRow: true,
                className: "w-10r",
            },
            {
                valueProp: "",
                title: "description",
                renderFn: this.renderDescriptionColFn,
                renderFnEmitsRow: true,
                className: "w-10r",
            },
            {
                valueProp: "",
                title: "qty",
                renderFn: this.renderQtyColFn,
                renderFnEmitsRow: true,
                className: "w-5r",
            },
            {
                valueProp: "",
                title: this.props.supplierModel.length_for_depth ? "length" : "depth",
                renderFn: this.renderDepthColFn,
                renderFnEmitsRow: true,
                className: "w-5r",
                notVisible: !purchaseOrderItems.some((item) => item.depth != null),
            },
            {
                valueProp: "",
                title: "qty_received",
                renderFn: this.renderQtyReceivedColFn,
                renderFnEmitsRow: true,
                className: "w-5r",
                notVisible: this.state.purchaseOrder ? this.state.purchaseOrder.po_state_id === PurchaseOrderStateEnum.PRELIMINARY : false,
            },
            {
                valueProp: "",
                title: "unit_price",
                renderFn: this.renderUnitPriceColFn,
                renderFnEmitsRow: true,
                className: "w-5r",
            },
            {
                valueProp: "",
                title: "total_price",
                renderFn: this.renderTotalPriceColFn,
                renderFnEmitsRow: true,
                className: "w-5r",
            },
        ];
    };

    onGetPurchaseOrder = (data: IOnGetPurchaseOrderDTO) => {
        let breadcrumbs = this.state.breadcrumbs;

        if (!this.state.completedCrumbs) {
            breadcrumbs = [
                ...breadcrumbs,
                {
                    url: `/purchase_orders/${this.state.purchaseOrderGuid}`,
                    title: `${data.purchaseOrder?.name}` || "Purchase Order",
                    skipTranslate: true,
                },
            ];

            document.title = `Orderwerks >> Purchase Orders >> ${data.purchaseOrder?.name}`;
        }

        const purchaseOrderItems: IPurchase_Order_ItemUI[] = (data.purchaseOrder.Purchase_Order_Items || []).map((item) => {
            return { ...item, editMode: false };
        });

        const currentPurchaseOrderItems = this.state.purchaseOrderItems || [];

        // carry over any changes if they have multiple line edit modes open
        for (const currentItem of currentPurchaseOrderItems) {
            for (const updatedItem of purchaseOrderItems) {
                if (currentItem.catalog_item_id === updatedItem.catalog_item_id && currentItem.editMode) {
                    updatedItem.editMode = currentItem.editMode;
                    updatedItem.qty = currentItem.qty;
                    updatedItem.unit_price = currentItem.unit_price;
                }
            }
        }

        const isReadOnly = data.purchaseOrder.po_state_id !== PurchaseOrderStateEnum.PRELIMINARY;

        this.setState(
            {
                completedCrumbs: true,
                breadcrumbs,
                isDataFetching: false,
                isInitialData: false,
                purchaseOrder: data.purchaseOrder,
                purchaseOrderItems,
                columns: this.getTableColumns(purchaseOrderItems),
                isReadOnly,
            },
            () => {
                this.setCurrentAndNextStep();
            }
        );
    };

    getVendorSource = () => {
        if (this.state.detailEditMode) {
            return this.state.purchaseOrder?.Vendor_Source?.name || "--";
        } else {
            return this.state.purchaseOrder?.Vendor_Source?.name || "--";
        }
    };

    getPurchaseOrderState = () => {
        if (this.state.detailEditMode) {
            // Do nothing?
        } else {
            return <OwLabel title={this.state.purchaseOrder?.Purchase_Order_State?.name.toLowerCase()} noBottomMargin={true} />;
        }
    };

    getShippingCarrier = () => {
        if (this.state.detailEditMode) {
            // Do nothing?
        } else {
            return this.state.purchaseOrder?.Shipping_Carrier?.name || "--";
        }
    };

    updateShipTo = (e: ChangeEvent<any>) => {
        if (this.state.purchaseOrder) {
            const name = e.target.name;
            const value = e.target.value;

            const shipTo = {
                ...(this.state.purchaseOrder.Ship_To || ({} as IAddress)),
            };

            // @ts-expect-error
            shipTo[name] = value;

            this.setState({
                purchaseOrder: {
                    ...this.state.purchaseOrder,
                    Ship_To: shipTo,
                },
            });
        }
    };

    getShipTo = () => {
        if (this.state.detailEditMode) {
            if (this.state.purchaseOrder) {
                return (
                    <div className={"d-flex"}>
                        <AddressBlock
                            fn={this.updateShipTo}
                            showCompanyName={true}
                            showName={true}
                            address={this.state.purchaseOrder.Ship_To}
                        />
                    </div>
                );
            } else {
                return "--";
            }
        } else {
            if (this.state.purchaseOrder) {
                return (
                    <div className={"d-flex"}>
                        {this.props.supplierModel.has_google_maps ? (
                            <OwGoogleStaticMap address={this.state.purchaseOrder.Ship_To!} size={"120x120"} className={"me-2"} />
                        ) : null}
                        <AddressDisplay showCompanyName={true} showName={true} address={this.state.purchaseOrder.Ship_To} />
                    </div>
                );
            } else {
                return "--";
            }
        }
    };

    getPO = () => {
        if (this.state.detailEditMode) {
            // Do nothing?
        } else {
            return this.state.purchaseOrder?.po_no || "--";
        }
    };

    getInternalNote = () => {
        if (this.state.detailEditMode) {
            return (
                <OwTextArea name={"internal_note"} fn={this.handlePurchaseOrderChange} value={this.state.purchaseOrder?.internal_note} />
            );
        } else {
            return this.state.purchaseOrder?.internal_note || "--";
        }
    };

    getRequiresApproval = () => {
        if (this.state.detailEditMode) {
            // Do nothing?
        } else {
            return this.state.purchaseOrder?.req_approval ? "Y" : "--";
        }
    };

    processPurchaseOrderItem = (row?: IPurchase_Order_Item) => {
        let purchaseOrderItem: IPurchase_Order_Item | INewPurchase_Order_Item;

        if (row) {
            purchaseOrderItem = {
                ...row,
            };
        } else {
            if (this.props.supplierModel.po_item_dupe_check) {
                if (this.state.purchaseOrderItems) {
                    for (const item of this.state.purchaseOrderItems) {
                        if (item.catalog_item_id === this.state.selectedTypeaheadItem!.id) {
                            this.setState({
                                alreadyExists: true,
                            });
                            return;
                        }
                    }
                }
            }

            purchaseOrderItem = {
                purchase_order_id: this.state.purchaseOrder!.id,
                unit_price: 0,
                catalog_item_id: this.state.selectedTypeaheadItem!.id,
                qty: this.state.qty,
                qty_units_id: UnitOfMeasurementEnum.EACH,
            };
        }

        const payload: IProcessPurchaseOrderItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            purchaseOrderItem,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessPurchaseOrderItem, payload);
    };

    onProcessPurchaseOrderItem = (data: IOnProcessPurchaseOrderItemDTO) => {
        const notification: INotification = {
            message: "successfully_processed_purchase_order_item",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getPurchaseOrder();
    };

    onProcessPurchaseOrder = (data: IOnProcessPurchaseOrderDTO) => {
        const notification: INotification = {
            message: "successfully_processed_purchase_order",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                isSubmitActive: false,
                sendEmailWithPDF: false,
            },
            () => {
                this.getPurchaseOrder();
            }
        );
    };

    typeaheadCatalogItems = (name: string) => {
        const payload: ITypeaheadVendorSourceCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            limit: 8,
            offset: 0,
            vendorSourceGuid: this.state.purchaseOrder!.Vendor_Source!.guid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadVendorSourceCatalogItems, payload);
    };

    onTypeaheadCatalogItems = (data: IOnTypeaheadVendorSourceCatalogItemsDTO) => {
        this.setState({
            typeaheadItems: data.catalog_items,
        });
    };

    selectedTypeaheadItem = (item: ICatalog_Item) => {
        this.setState(
            {
                selectedTypeaheadItem: item,
                alreadyExists: false,
            },
            () => {
                document.getElementById("orderQty")?.focus();
            }
        );
    };

    clearTypeaheadFn = () => {
        this.setState({
            clearTypeahead: false,
            alreadyExists: false,
        });
    };

    handlePurchaseOrderChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const _purchaseOrder = { ...this.state.purchaseOrder };
        // @ts-expect-error
        _purchaseOrder[name] = value;

        if (_purchaseOrder) {
            this.setState({
                // @ts-expect-error
                purchaseOrder: _purchaseOrder,
            });
        }
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    setCurrentAndNextStep = () => {
        if (this.state.purchaseOrder) {
            const purchaseOrderSteps: IPurchase_Order_Progress_State[] = OrderEntryService.getPurchaseOrderSteps(this.props.supplierModel);

            const currentStep = this.state.purchaseOrder.Purchase_Order_State!.id;
            let currentStepNo: number | undefined = undefined;
            let nextStep: number | undefined = undefined;

            let isReadOnlyStep = 0;

            for (const step of purchaseOrderSteps) {
                if (step.order_state_id === currentStep) {
                    currentStepNo = step.step_no;
                }

                if (currentStepNo && step.step_no === currentStepNo + 1) {
                    nextStep = step.order_state_id;
                }

                if (step.isReadOnly) {
                    if (currentStepNo && step.step_no < currentStepNo) {
                        isReadOnlyStep = step.step_no;
                    } else {
                        isReadOnlyStep = step.step_no;
                    }
                }
            }

            const isReadOnly = this.props.isReadOnly || isReadOnlyStep <= currentStep;

            console.log("isReadOnly", isReadOnly, this.props.isReadOnly, isReadOnlyStep, currentStep);

            this.setState({
                currentStep,
                nextStep,
                isReadOnly,
            });
        }
    };

    advancePurchaseOrder = (stateOverride?: number) => {
        let hasStateChange = false;
        let changeState: number | undefined;

        if (this.state.nextStep) {
            hasStateChange = true;
            changeState = this.state.nextStep;
        }

        if (!_.isNil(stateOverride)) {
            hasStateChange = true;
            changeState = stateOverride;
        }

        if (changeState && this.state.purchaseOrder) {
            const payload: IProcessPurchaseOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                purchaseOrder: {
                    ...this.state.purchaseOrder,
                    po_state_id: changeState,
                },
                sendEmailWithPDF: this.state.sendEmailWithPDF,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessPurchaseOrder, payload);

            this.setState({
                isSubmitActive: true,
            });
        }
    };

    confirmAutoPopulate = () => {
        const modalComponent = (
            <SimpleConfirmModal
                message={"auto_populate_confirm_message"}
                cancelFn={this.closeAutoPopulateModal}
                confirmFn={this.commitAutoPopulate}
            />
        );

        this.props.uiContext.setModalComponent(modalComponent);
        this.props.uiContext.showModal(true);
    };

    closeAutoPopulateModal = () => {
        this.props.uiContext.setModalComponent(null);
        this.props.uiContext.showModal(false);
    };

    commitAutoPopulate = () => {
        this.closeAutoPopulateModal();
        this.autoPopulate();
    };

    autoPopulate = () => {
        const payload: IPurchaseOrderAutoPopulateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            purchaseOrderGuid: this.state.purchaseOrderGuid,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderAutoPopulate, payload);

        this.setState({
            isSubmitActive: true,
        });
    };

    onAutoPopulate = (data: IOnPurchaseOrderAutoPopulateDTO) => {
        this.setState(
            {
                isSubmitActive: false,
                sendEmailWithPDF: false,
            },
            () => {
                this.getPurchaseOrder();
            }
        );
    };

    getExpectedDate = (item: ICatalog_Item): string => {
        let expectedDate = "--";

        if (this.state.purchaseOrder) {
            const vendorSource = this.state.purchaseOrder.Vendor_Source;

            if (vendorSource) {
                expectedDate = CatalogItemService.getVendorSourceExpectedDate(vendorSource, item);
            }
        }

        return expectedDate;
    };

    renderTypeaheadItem = (item: ICatalog_Item) => {
        const vendorSource = this.state.purchaseOrder!.Vendor_Source!;

        const expectedDate = this.getExpectedDate(item);
        const leadTime = CatalogItemService.getLeadTime(vendorSource, item);

        const details = (
            <div>
                <div>{item.name}</div>
                <div className={"text-muted text-small"}>{item.sku}</div>
                <div>
                    <OwLabel title={"lead_time"} className={"me-2"} noBottomMargin={true} postText={":"} />
                    {leadTime}
                </div>
                <div>
                    <OwLabel title={"expected_date"} className={"me-2"} noBottomMargin={true} postText={":"} />
                    {expectedDate}
                </div>
            </div>
        );

        return details;
    };

    sendPurchaseOrder = () => {
        if (this.state.purchaseOrder) {
            const payload: ISendPurchaseOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                poGuid: this.state.purchaseOrder.guid,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderSendPurchaseOrder, payload);

            this.setState({
                isDownloading: true,
            });
        }
    };

    onSendPurchaseOrder = (data: IOnSendPurchaseOrderDTO) => {
        const notification: INotification = {
            message: "successfully_sent_purchase_order",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                isDownloading: false,
            },
            () => {
                this.getPurchaseOrder();
            }
        );
    };

    downloadPdf = () => {
        if (this.state.purchaseOrder) {
            const payload: IDownloadPurchaseOrderPdfDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                purchaseOrderGuid: this.state.purchaseOrder.guid,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderDownloadPurchaseOrderPdf, payload);

            this.setState({
                isDownloading: true,
            });
        }
    };

    onDownloadPdf = (data: IOnDownloadPurchaseOrderPdfDTO) => {
        const blob = new Blob([data.pdfData], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const fileName = data.filename;

        link.download = _.get(this.props, "fileName", `${fileName}`);
        link.click();

        this.setState({
            isDownloading: false,
        });
    };

    cancelPOSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.getPurchaseOrder();
        }
    };

    showCreateQboPurchaseOrderSidebar = () => {
        if (this.state.purchaseOrder) {
            const sidebar = (
                <CreateQboPurchaseOrderSidebar
                    cancelFn={this.cancelPOSidebar}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    purchaseOrder={this.state.purchaseOrder}
                    location={this.props.location}
                    history={this.props.history}
                />
            );

            this.props.setSidebarComponent(sidebar);
            this.props.toggleSidebar(true);
        }
    };

    viewQboPurchaseOrder = () => {
        if (this.state.purchaseOrder) {
            const sidebar = (
                <QboViewPurchaseOrderSidebar
                    purchaseOrder={this.state.purchaseOrder}
                    supplierModel={this.props.supplierModel}
                    userModel={this.props.userModel}
                    notifyFn={this.props.notifyFn}
                    socket={this.props.socket}
                    cancelFn={this.cancelPOSidebar}
                />
            );

            this.props.setSidebarComponent(sidebar);
            this.props.toggleSidebar(true);
        }
    };

    emailQboPurchaseOrder = () => {
        if (this.state.purchaseOrder?.qbo_PurchaseOrderId) {
            const payload: IQBOSendPurchaseOrderDTO = {
                qbo_purchaseOrderId: this.state.purchaseOrder.qbo_PurchaseOrderId,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.QBOSendPurchaseOrder, payload);

            this.setState({
                qboActive: true,
            });
        }
    };

    onQboSendPurchaseOrder = (data: IQBOOnSendPurchaseOrderDTO) => {
        const notification: INotification = {
            message: "successfully_sent_purchase_order",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qboActive: false,
            },
            () => {
                this.getPurchaseOrder();
            }
        );
    };

    deleteQboPurchaseOrder = () => {
        if (this.state.purchaseOrder?.qbo_PurchaseOrderId) {
            const payload: IQBODeletePurchaseOrderDTO = {
                qbo_PurchaseOrderId: this.state.purchaseOrder.qbo_PurchaseOrderId,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.QBODeletePurchaseOrder, payload);

            this.setState({
                qboActive: true,
            });
        }
    };

    onDeleteQboPurchaseOrder = () => {
        const notification: INotification = {
            message: "successfully_deleted_purchase_order",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qboActive: false,
            },
            () => {
                this.getPurchaseOrder();
            }
        );
    };

    onNotify = () => {
        this.setState({
            qboActive: false,
            isSubmitActive: false,
            isDownloading: false,
        });
    };

    cancelSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    processedShipmentFn = () => {
        // close sidebar?
    };

    updatedShipmentFn = () => {};

    showShipmentSidebar = () => {
        if (this.state.purchaseOrder) {
            const component = (
                <ShipmentPackageSidebar
                    cancel={this.cancelSidebar}
                    notifyFn={this.props.notifyFn}
                    socket={this.props.socket}
                    processedFn={this.processedShipmentFn}
                    onUpdateFn={this.updatedShipmentFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    purchaseOrder={this.state.purchaseOrder}
                />
            );

            this.props.setSidebarComponent(component);
            this.props.toggleSidebar(true);
        }
    };

    toggleDetailEditMode = () => {
        this.setState({
            detailEditMode: !this.state.detailEditMode,
        });
    };

    updatePurchaseOrder = () => {
        if (this.state.purchaseOrder) {
            const payload: IProcessPurchaseOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                purchaseOrder: {
                    guid: this.state.purchaseOrder.guid,
                    vendor_source_id: this.state.purchaseOrder.vendor_source_id,
                    po_state_id: this.state.purchaseOrder.po_state_id,
                    Ship_To: this.state.purchaseOrder.Ship_To || {},
                    internal_note: this.state.purchaseOrder.internal_note,
                },
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessPurchaseOrder, payload);

            this.setState({
                isSubmitActive: true,
                detailEditMode: false,
            });
        }
    };

    receiveShipment = async () => {
        if (!this.state.purchaseOrder) return;

        try {
            const data = await PurchaseOrderService.createPOShipment(
                this.state.purchaseOrder.guid,
                this.state.purchaseOrder.vendor_source_id,
                this.props.userModel,
                this.props.supplierModel
            );

            if (data.success && data.poShipment) {
                this.props.history(`/purchase_orders/process_shipment/${data.poShipment.guid}`);
            } else {
                this.props.notifyFn(null, {
                    message: data.message || "Failed to create PO shipment",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                });
            }
        } catch (error: any) {
            console.error("Failed to create PO shipment:", error);
            this.props.notifyFn(null, {
                message: error.message || "Failed to create PO shipment",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            });
        }
    };

    purchaseOrderButtonsCallbacks: IPurchaseOrderButtonsCallbacks = {
        handleChange: this.handleChange,
        advancePurchaseOrder: this.advancePurchaseOrder,
        sendPurchaseOrder: this.sendPurchaseOrder,
        downloadPdf: this.downloadPdf,
        showShipmentSidebar: this.showShipmentSidebar,
        receiveShipment: this.receiveShipment,
    };

    otherPurchaseOrderButtonsCallbacks: IOtherPurchaseOrderButtonsCallbacks = {
        viewQboPurchaseOrder: this.viewQboPurchaseOrder,
        emailQboPurchaseOrder: this.emailQboPurchaseOrder,
        deleteQboPurchaseOrder: this.deleteQboPurchaseOrder,
        showCreateQboPurchaseOrderSidebar: this.showCreateQboPurchaseOrderSidebar,
    };

    render() {
        const purchaseOrderSteps: IPurchase_Order_Progress_State[] = OrderEntryService.getPurchaseOrderSteps(this.props.supplierModel);

        return (
            <div className="PurchaseOrderDetail position-relative">
                <Breadcrumbs crumbs={this.state.breadcrumbs} className={"mb-3"} />

                <div className={"d-flex"}>
                    <div>
                        <div className={"d-flex align-items-center"}>
                            <div className={"d-flex align-items-center"}>
                                <OwTitle title={"purchase_order"} className={"me-2"} tag={"h4"} />
                                <OwTitle title={this.state.purchaseOrder?.name || ""} tag={"h4"} disableTranslation={true} />
                            </div>

                            <div className={"ms-2"}>
                                <OwPill
                                    title={this.state.purchaseOrder?.is_emailed ? "emailed" : "not_emailed"}
                                    leftIconClass={
                                        "fad text-white " +
                                        (this.state.purchaseOrder?.is_emailed ? "fa-envelope-circle-check" : "fa-envelope")
                                    }
                                    className={"text-white px-2 " + (this.state.purchaseOrder?.is_emailed ? "bg-success" : "bg-danger")}
                                />
                            </div>
                        </div>
                        {this.state.purchaseOrder?.expected_date ? (
                            <div>
                                <OwLabel title={"estimated_dates"} noBottomMargin={true} postText={":"} className={"me-2"} />
                                {UserService.parseDate(this.state.purchaseOrder.expected_date)}
                                {this.state.purchaseOrder.expected_end_date
                                    ? ` - ` + UserService.parseDate(this.state.purchaseOrder.expected_end_date)
                                    : null}
                            </div>
                        ) : null}
                        {this.state.purchaseOrder?.Order ? (
                            <div>
                                <Link to={`/orders/${this.state.purchaseOrder.Order.guid}/entry`}>
                                    <OwLabel title={"order"} className={"me-1"} />
                                    {this.state.purchaseOrder.Order.name}
                                </Link>
                            </div>
                        ) : null}
                    </div>

                    <div className={"ms-auto d-flex flex-column justify-content-end"}>
                        <PurchaseOrderButtons
                            purchaseOrder={this.state.purchaseOrder}
                            purchaseOrderSteps={purchaseOrderSteps}
                            nextStep={this.state.nextStep}
                            order_state_id={this.state.order_state_id}
                            isSubmitActive={this.state.isSubmitActive}
                            isDownloading={this.state.isDownloading}
                            isReadOnly={this.state.isReadOnly}
                            sendEmailWithPDF={this.state.sendEmailWithPDF}
                            isAdminSupplierUser={
                                this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN
                            }
                            callbacks={this.purchaseOrderButtonsCallbacks}
                        />
                    </div>
                </div>

                <div className={"d-flex justify-content-end mt-2"}>
                    <OtherPurchaseOrderButtons
                        purchaseOrder={this.state.purchaseOrder}
                        qboActive={this.state.qboActive}
                        isAdminUser={
                            !!this.props.userModel.supplierUserToken?.User_Type?.id &&
                            this.props.userModel.supplierUserToken.User_Type.id === UserTypesEnum.ADMIN
                        }
                        hasQbo={this.props.supplierModel.Supplier_Integration?.has_qbo || false}
                        callbacks={this.otherPurchaseOrderButtonsCallbacks}
                    />
                </div>

                <div className={"d-flex w-100 justify-content-center align-items-center"}>
                    {this.state.purchaseOrder ? <PurchaseOrderProgressTracker purchaseOrder={this.state.purchaseOrder} /> : null}
                </div>

                <Tabs>
                    <TabList>
                        <Tab>
                            <OwLabel title={"details"} className={"pointer"} />
                        </Tab>
                        <Tab>
                            <OwLabel title={"files"} className={"pointer"} />
                        </Tab>
                        <Tab>
                            <OwLabel title={"shipments"} className={"pointer"} />
                        </Tab>
                    </TabList>
                    <TabPanel>
                        <div className={"p-2"}>
                            <div className={this.state.isReadOnly ? "d-none" : "mb-2"}>
                                {this.state.isReadOnly ? null : (
                                    <OwButton
                                        className={
                                            this.state.detailEditMode
                                                ? "d-none"
                                                : "d-inline-flex align-items-center pointer bottom-border-on-hover-warning d-print-none btn btn-warning btn-sm"
                                        }
                                        title={"edit"}
                                        leftIconClass={"fas fa-pencil"}
                                        fn={this.toggleDetailEditMode}
                                    />
                                )}
                                <span className={this.state.detailEditMode ? "d-inline-flex align-items-center" : "d-none"}>
                                    <ButtonGroup>
                                        <OwButton
                                            className={"bg-success text-white"}
                                            title={"save"}
                                            leftIconClass={"fas fa-check"}
                                            fn={this.updatePurchaseOrder}
                                        />

                                        <OwButton
                                            className={"bg-danger text-white"}
                                            title={"cancel"}
                                            leftIconClass={"fas fa-times"}
                                            fn={() => {
                                                this.toggleDetailEditMode();
                                            }}
                                        />
                                    </ButtonGroup>
                                </span>
                            </div>
                            <div className={""}>
                                <div className={"row"}>
                                    <div className={"col-4"}>
                                        <div>
                                            <OwLabel title={"vendor_source"} isBold={true} postText={":"} className={"me-2"} />
                                            {this.getVendorSource()}
                                        </div>

                                        <div>
                                            <OwLabel title={"ship_to"} isBold={true} />
                                            {this.getShipTo()}
                                        </div>
                                    </div>

                                    <div className={"col-4"}>
                                        {/*<div>*/}
                                        {/*    <OwLabel title={'po_no'} isBold={true} postText={':'} className={'me-2'}/>*/}
                                        {/*    {this.getPO()}*/}
                                        {/*</div>*/}

                                        <div>
                                            <OwLabel title={"internal_note"} isBold={true} postText={":"} className={"me-2"} />
                                            {this.getInternalNote()}
                                        </div>

                                        {/*<div>*/}
                                        {/*    <OwLabel title={'shipping_carrier'} isBold={true} postText={':'} className={'me-2'}/>*/}
                                        {/*    {this.getShippingCarrier()}*/}
                                        {/*</div>*/}

                                        {/*<div>*/}
                                        {/*    <OwLabel title={'requires_approval'} isBold={true} postText={':'} className={'me-2'}/>*/}
                                        {/*    {this.getRequiresApproval()}*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={"p-2"}>
                            {this.state.purchaseOrder ? (
                                <PurchaseOrderFileManager
                                    socket={this.props.socket}
                                    purchaseOrder={this.state.purchaseOrder}
                                    isReadOnly={this.state.isReadOnly}
                                />
                            ) : null}
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={"p-2"}>
                            {this.state.purchaseOrder ? (
                                <PurchaseOrderShipmentsDetailView
                                    purchaseOrder={this.state.purchaseOrder}
                                    userModel={this.props.userModel}
                                    supplierModel={this.props.supplierModel}
                                    isReadOnly={this.state.isReadOnly}
                                    uiContext={this.props.uiContext}
                                />
                            ) : null}
                        </div>
                    </TabPanel>
                </Tabs>

                {this.state.isReadOnly ? null : (
                    <div className={"mt-2 d-print-none"}>
                        <OwLabel title={"search"} noBottomMargin={true} />
                        <div className={"d-flex"}>
                            <div className={"w-20r"}>
                                <Typeahead
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    typeaheadApiFn={this.typeaheadCatalogItems}
                                    typeaheadItems={this.state.typeaheadItems}
                                    itemsRenderFn={this.renderTypeaheadItem}
                                    titleProp={"name"}
                                    selectedItemFn={this.selectedTypeaheadItem}
                                    clearTypeaheadCallback={this.clearTypeaheadFn}
                                    clearTypeahead={this.state.clearTypeahead}
                                    selectedItem={this.state.selectedTypeaheadItem}
                                    selectedItemTitleProp={"name"}
                                />
                            </div>
                            <div className={"w-5r ms-1"}>
                                <OwInputWrapper
                                    id={"orderQty"}
                                    type={"number"}
                                    name={"qty"}
                                    fn={this.handleChange}
                                    value={this.state.qty}
                                    min={0}
                                />
                            </div>
                            <div className={"ms-1"}>
                                <OwButton
                                    leftIconClass={"fas fa-plus"}
                                    title={"add"}
                                    fn={() => {
                                        this.processPurchaseOrderItem();
                                    }}
                                    active={this.state.isSubmitActive}
                                    disableOnActive={true}
                                />
                            </div>
                            <div className={"ms-auto"}>
                                <OwButton
                                    title={"auto_populate"}
                                    fn={this.confirmAutoPopulate}
                                    active={this.state.isSubmitActive}
                                    disableOnActive={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {this.state.alreadyExists ? (
                    <div>
                        <OwLabel title={"item_already_exists"} className={"text-danger"} />
                    </div>
                ) : null}

                <div className={"mt-2 position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElem}
                        handleConfirm={this.confirmDelete}
                        handleCancel={this.cancelDelete}
                        nestedParentElem={"purchase-order-detail"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"purchase-order-detail"}
                        columns={this.state.columns}
                        dataSet={this.state.purchaseOrderItems || []}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                    />
                </div>
            </div>
        );
    }
}

export default PurchaseOrderDetail;
